import { render } from "./Product03.vue?vue&type=template&id=f900177c"
import script from "./Product03.vue?vue&type=script&lang=js"
export * from "./Product03.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__